import React from 'react';

const BillingActions = ({ newGroup, unassignGroups, syncGroups }) => {
    return (
        <div className="billing-action-bar mb-4">
            <div className="action-group-left">
                <button className="btn-primary-custom" onClick={newGroup}>
                    <i className="fa fa-plus"></i>
                    <span>New Fees Group</span>
                </button>
                
                <div className="action-separator"></div>

                <button className="btn-ghost-custom" onClick={syncGroups}>
                    <i className="fa fa-sync text-success"></i>
                    <span>Sync Groups</span>
                </button>
            </div>

            <div className="action-group-right">
                <button className="btn-ghost-custom" onClick={unassignGroups}>
                    <i className="fa fa-trash-alt text-danger"></i>
                    <span>Unassign</span>
                </button>
                
                <button className="btn-ghost-custom">
                    <i className="fa fa-history"></i>
                    <span>Revert Recent Bills</span>
                </button>
            </div>
        </div>
    );
};

export default BillingActions;